/** Hosting regions, mirroring the `Region` enum in PrivateWorldsCommon. `code` is what the API stores and accepts. */
export const REGIONS: { code: string; name: string; hint: string }[] = [
  { code: 'GER', name: 'Europe', hint: 'Germany · best for Europe, the UK and Africa' },
  { code: 'US_WEST', name: 'West US', hint: 'Best for the US west coast and Oceania' },
  { code: 'US_EAST', name: 'East US', hint: 'Best for the US east coast and South America' },
  { code: 'SING', name: 'Asia', hint: 'Singapore · best for Asia and India' },
];

/**
 * Convert region ID to friendly name
 * @param regionId The region ID (e.g., 'GER', 'US_WEST', 'US_EAST', 'SING')
 * @returns The friendly name for the region
 */
export const getRegionFriendlyName = (regionId?: string): string => {
  if (!regionId) return 'Unknown';
  const region = REGIONS.find((r) => r.code === regionId);
  return region ? region.name : regionId;
};
